import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { publicApi } from '../lib/api';
import PlayerCard from './PlayerCard';

export default function RosterPreview() {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicApi.getPlayers().then(res => {
      // Shuffle players randomly for homepage preview
      const shuffled = [...res.data].sort(() => Math.random() - 0.5);
      setPlayers(shuffled.slice(0, 4));
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
      {[1, 2, 3, 4].map(i => (
        <div key={i} className="bg-[hsl(0,0%,8%)] border border-white/10 rounded-xl animate-pulse">
          <div className="aspect-[3/4]" /><div className="p-4"><div className="h-4 bg-white/5 rounded w-2/3 mb-2" /><div className="h-3 bg-white/5 rounded w-1/3" /></div>
        </div>
      ))}
    </div>
  );

  if (players.length === 0) return (
    <div className="bg-[hsl(0,0%,8%)] border border-white/10 rounded-xl p-12 text-center">
      <p className="text-white/40 text-sm mb-2">Noch keine Spieler hinzugefügt</p>
      <p className="text-white/20 text-xs">Spieler können im Admin-Bereich verwaltet werden</p>
    </div>
  );

  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
        {players.map((player, index) => (
          <PlayerCard key={player._id} player={player} index={index} />
        ))}
      </div>
      <div className="mt-10 text-center">
        <Link
          to="/kader"
          className="inline-flex items-center gap-2 px-7 py-3.5 bg-white/5 text-white border border-white/10 font-bold rounded-lg hover:bg-white/10 active:scale-[0.98] transition-colors duration-200 text-sm uppercase tracking-wider"
          data-testid="roster-preview-cta"
        >
          Gesamten Kader ansehen
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
